// This file mocks external API calls which would normally require valid API keys.

export const searchPlace = async (query: string): Promise<{ address: string; lat: number; lng: number }[]> => {
    // Simulate network delay
    await new Promise(resolve => setTimeout(resolve, 600));

    if (!query) return [];

    // Mock results
    return [
        { address: `${query}, USA`, lat: 40.7128, lng: -74.0060 },
        { address: `${query} City, UK`, lat: 51.5074, lng: -0.1278 },
        { address: `New ${query}, Australia`, lat: -33.8688, lng: 151.2093 },
    ];
};

export const getTimezone = async (lat: number, lng: number): Promise<string> => {
    // Simulate network delay
    await new Promise(resolve => setTimeout(resolve, 300));
    return "America/New_York"; // Mock timezone
};
